import { ApolloClient, ApolloLink, from, InMemoryCache, split, } from '@apollo/client';
import { WebSocketLink } from '@apollo/client/link/ws';
import { getMainDefinition } from '@apollo/client/utilities';
import ApolloLinkTimeout from 'apollo-link-timeout';
import { createUploadLink } from 'apollo-upload-client';
import { deepOmitAll } from '../helpers/utils';
import { generateConf } from './axios';
const onUnauthorizedCb = () => {
    return true;
};
export const createApolloClient = ({ url, wsUrl, wsOptions, memoryCacheConfig, typeDefs, }) => {
    const axiosInstance = generateConf({ baseURL: url }, onUnauthorizedCb);
    let link;
    const fetchWithAxios = async (uri, options) => {
        const { body, headers, credentials, ...postConfig } = options;
        const customHeaders = {
            ...headers,
        };
        const result = await axiosInstance.post(uri, body, {
            ...postConfig,
            headers: customHeaders,
            timeout: 100000,
            responseType: 'text',
        });
        const defaultResponseType = 'default';
        const fakeResponse = {
            headers: result.headers,
            ok: result.status === 200,
            status: result.status,
            statusText: result.statusText,
            redirected: false,
            trailer: Promise.resolve(result.headers),
            type: defaultResponseType,
            url: result.config.url || '',
            body: result.data,
            bodyUsed: true,
            arrayBuffer: async () => new ArrayBuffer(0),
            blob: async () => new Blob(),
            formData: async () => new FormData(),
            json: async () => Promise.resolve(result.data),
            text: async () => Promise.resolve(JSON.stringify(result.data)),
        };
        return Promise.resolve(fakeResponse);
    };
    const inputCleanseMiddleware = new ApolloLink((operation, forward) => {
        if (operation.variables) {
            const def = getMainDefinition(operation.query);
            if (def && def.operation === 'mutation') {
                operation.variables = deepOmitAll('__typename', operation.variables);
            }
        }
        return forward(operation);
    });
    const timeoutLink = new ApolloLinkTimeout(100000);
    const httpLink = createUploadLink({
        fetch: fetchWithAxios,
    });
    if (wsUrl) {
        const wsLink = new WebSocketLink({
            uri: wsUrl,
            options: {
                connectionParams: () => ({
                    Authorization: axiosInstance.defaults.headers.authorization || '',
                    tenantId: axiosInstance.defaults.headers['x-tenant-id'] || '',
                }),
                reconnect: true,
                lazy: true,
                ...wsOptions,
            },
        });
        link = split(({ query }) => {
            const definition = getMainDefinition(query);
            return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
        }, wsLink, httpLink);
    }
    const timeoutHttpLink = timeoutLink.concat(link || httpLink);
    const apolloClient = new ApolloClient({
        connectToDevTools: true,
        link: from([inputCleanseMiddleware, timeoutHttpLink]),
        cache: new InMemoryCache(memoryCacheConfig),
        typeDefs,
    });
    apolloClient.setAuthToken = (tenantId, authTokens) => {
        const { token, impersonationToken } = authTokens;
        axiosInstance.defaults.headers.authorization = `Bearer ${token}`;
        axiosInstance.defaults.headers['x-tenant-id'] = tenantId;
        if (impersonationToken) {
            axiosInstance.defaults.headers['x-impersonation'] = `Bearer ${impersonationToken}`;
        }
    };
    return apolloClient;
};
//# sourceMappingURL=clientGenerator.js.map